interface KpiCardProps {
  icon: string;
  label: string;
  value: string;
  iconClass?: string;
  sub?: string;
  delta?: number | null;
}

/**
 * Carte KPI du centre de vue globale. Grand chiffre, libellé, icône colorée,
 * et variation optionnelle par rapport à la période précédente (traction).
 */
export default function KpiCard({
  icon,
  label,
  value,
  iconClass = 'bg-primary-100 text-primary-700',
  sub,
  delta,
}: KpiCardProps) {
  const hasDelta = delta != null && Number.isFinite(delta);
  const positive = (delta ?? 0) >= 0;
  const deltaText = hasDelta
    ? `${positive ? '+' : ''}${(delta as number).toFixed(1)}%`
    : '';

  return (
    <div className="bg-background-50 border border-background-200/70 rounded-lg p-4 md:p-5 h-full">
      <div className="flex items-start justify-between gap-3">
        <div className="min-w-0">
          <div className="text-xs font-medium text-foreground-500 leading-snug mb-1.5">
            {label}
          </div>
          <div className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 truncate">
            {value}
          </div>
          {(hasDelta || sub) && (
            <div className="flex items-center gap-2 mt-1 min-w-0">
              {hasDelta && (
                <span
                  className={`inline-flex items-center gap-0.5 text-[11px] font-semibold rounded-full px-1.5 py-0.5 whitespace-nowrap ${
                    positive
                      ? 'text-accent-700 bg-accent-100'
                      : 'text-red-600 bg-red-50'
                  }`}
                >
                  <i className={positive ? 'ri-arrow-up-line' : 'ri-arrow-down-line'}></i>
                  {deltaText}
                </span>
              )}
              {sub && (
                <span className="text-[11px] text-foreground-400 truncate">{sub}</span>
              )}
            </div>
          )}
        </div>
        <div className={`w-10 h-10 md:w-11 md:h-11 rounded-lg flex items-center justify-center flex-shrink-0 ${iconClass}`}>
          <i className={`${icon} text-lg md:text-xl`}></i>
        </div>
      </div>
    </div>
  );
}